export const ExperimentNames = {
    UseWarmupData: 'specs.events.ui.UseWarmupData',
    ImageSettings: 'specs.events.ui.ImageSettings',
    NewWidgetSettingsGFPP: 'specs.events.ui.NewWidgetSettingsGFPP',
    MyEventsNewName: 'specs.events.ui.MyEventsNewName',
    DisableMembersSiteCreation: 'specs.events.ui.DisableMembersSiteCreation',
    SEOScheduleURL: 'specs.events.ui.SEOScheduleURL',
    ShowCouponInputInPaymentStep: 'specs.events.ui.ShowCouponInputInPaymentStep',
    SelectEventsManually: 'specs.events.ui.SelectEventsManually',
    UseInfraCurrencyFormatter: 'specs.events.ui.UseInfraCurrencyFormatter',
    RsvpButtonSettings: 'specs.events.ui.RsvpButtonSettings',
    SplitRegButtonDefaults: 'specs.events.ui.SplitRegButtonDefaults',
    PriceOptionsBM: 'specs.events.ui.PriceOptionsBM',
    TicketPreview: 'specs.events.ui.TicketPreview',
};
//# sourceMappingURL=experiments.js.map